import React from 'react';
import './LoginPage.css';

const LoginPage = ({ onSubmit, onChange, showError }) => {

    const [focus, setFocus] = React.useState(false)
    const [dimensions] = React.useState({ 
        height: window.innerHeight,
        width: window.innerWidth
    })

    React.useEffect(() => {
        function handleResize() {
            if((window.innerWidth + window.innerHeight) < (dimensions.width + dimensions.height)){
                setFocus(true)
            } else{
                setFocus(false)
            }
        }
        
        window.addEventListener('resize', handleResize)

        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    return (
        <div className='flex-center login-page-container'>
            <form onSubmit={onSubmit} className='login-form'>
                Enter Password
                {showError && <span className='login-error'>Login Failed. Please check your password</span>}
                <input 
                    className='login-input' 
                    type="password" 
                    placeholder='Password' 
                    onChange={onChange} />
                <input className='login-submit' type="submit" value="Submit" />
            </form>
        </div>
    )
}

export default LoginPage;
